<template>
  <div class="time-submission">
    <div
      v-if="showCountDown"
      v-show="isCountDownReady"
      class="time-submission-lander"
      :class="{
        'white': isTextColourLight,
        'no-background': sharePresentation || !isPresenting,
      }"
    >
      <div class="time-submission-countdown">
        <CountDownV2
          :theme="isTextColourLight ? 'dark' : 'light'"
          @countDownReady="isCountDownReady = true"
        />
      </div>
      <div
        class="toggler cursor-pointer ml-auto"
        :class="{
          'active': isPopoverVisible
        }"
        @click="setPopoverVisible(!isPopoverVisible)"
      >
        <i class="fas fa-chevron-right"></i>
      </div>
      <div
        v-if="isPopoverVisible"
        class="time-submission-popover"
        :class="{
          'white': isTextColourLight,
          'no-background': sharePresentation || !isPresenting,
        }"
      >
        <div
          v-for="timeLimit in [10,20,30,40]"
          :key="timeLimit"
          class="time-submission-option"
          @click="setTime(timeLimit)"
        >
          {{ `${timeLimit} sec` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Util from '@/util'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'

import CountDownV2 from '@/components/presentations/CountDownV2.vue'

export default {
  components: {
    CountDownV2,
  },
  data() {
    return {
      isCountDownReady: false,
      isPopoverVisible: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    showCountDown() {
      const validScreen = (this.isPresenting || this.isBackstage)
        && !this.sharePresentation
      const validPresentationSetting = this.presentation
        && !JSON.parse(this.presentation.audiencePacing)
      const validSlideSetting = this.slideActive
        && this.slideActive.id
        && this.slideActive.hasTimeLimit
        && !this.slideActive.stopSubmission

      return validScreen
        && validPresentationSetting
        && validSlideSetting
    },
    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },
  },
  watch: {
    'slideActive.id': {
      handler() {
        this.setPopoverVisible(false)
        this.isCountDownReady = false
      },
      immediate: true,
    },
    showCountDown: {
      handler(value) {
        if (!value && this.isCountDownReady) {
          this.isCountDownReady = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    setPopoverVisible(visible = true) {
      this.isPopoverVisible = visible
    },
    setTime(value) {
      this.updateSlideActiveAction({
        timeToAnswer: value,
      })
      this.setPopoverVisible(false)
      EventBus.$emit('resetTimeToAnswer')
      Util.mixpanelTracking(eventCategories.PRESENTING_MODE, 'Update time limit from Menu', value)
    },
  },
}
</script>

<style lang="scss" scoped>
%theme-placeholder {
  &:not(.white) {
    background: rgba(255, 255, 255, 0.7);
    outline: 1px solid #D1D1D1;
  }

  &.white {
    background: rgba(0, 0, 0, 0.7);
    outline: 1px solid rgba(0, 0, 0, 0.7);
  }

  &.no-background {
    background: transparent;
    backdrop-filter: unset;
  }
}

.time-submission {
  @apply relative;
  font-size: 20px;
  z-index: 30;
  transition: all 0.2s ease;
}

.time-submission-lander {
  @apply absolute;
  @apply flex items-center;
  padding: 6px 12px;
  left: 22px;
  bottom: -24px;
  border-radius: 27px;
  min-height: 48px;
  @extend %theme-placeholder;

  .toggler {
    font-size: 1rem;
    line-height: 1;
    color: #707070;
    padding-top: 1px;

    &:hover, &.active {
      color: #313131;
    }
  }

  &.white {
    .toggler {
      color: rgba(#fff, 0.6);

      &:hover, &.active {
        color: #fff;
      }
    }
  }
}

.time-submission-popover {
  @apply absolute bottom-0 px-4 py-2 rounded-lg;
  left: calc(100% + 8px);
  width: 120px;
  font-size: 14px;
  @extend %theme-placeholder;

  color: #707070;

  .time-submission-option {
    padding-top: 4px;
    padding-bottom: 4px;

    &:hover {
      color: #313131;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(49, 49, 49, 0.15);
    }
  }

  &.white {
    color: rgba(255, 255, 255, 0.6);

    .time-submission-option {
      &:hover {
        color: #fff;
      }

      &:not(:last-child) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
    }
  }
}

.time-submission-option {
  @apply cursor-pointer;
}
</style>
